module.exports = __webpack_public_path__ + "img/buttonSearch.9f46f930.svg";